
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import Vue from 'vue';

window.Vue = Vue;

/**
 * Lang.js
 */
import Lang from 'lang.js';
Vue.prototype.trans = new Lang({
	messages: window.messages ? window.messages : [],
	locale: window.default_locale,
	fallback: window.fallback_locale,
});

/**
 * Vue Components 
 */
// User
Vue.component('reservation-calendar', require('./components/ReservationCalendar.vue').default);
Vue.component('company-list', require('./components/CompanyList.vue').default);
Vue.component('user-reservations-datatable', require('./components/UserReservationsDatatable.vue').default);

// Company
Vue.component('company-register-component', require('./components/CompanyRegisterComponent.vue').default);
Vue.component('company-reservations-overview', require('./components/CompanyReservationsOverview.vue').default);
Vue.component('company-timeslot-form', require('./components/CompanyTimeslotForm.vue').default);
Vue.component('company-staff-form', require('./components/CompanyStaffForm.vue').default);

// Dynamic loading: Vue.component('reservation-component', () => import(/* webpackChunkName: "reservation-component" */ './components/ReservationComponent.vue'));

Vue.component('v-style', {
    render: function (createElement) {
      return createElement('style', this.$slots.default)
    }
});

/**
 * Import Components
 */
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

import VueGoodTablePlugin from 'vue-good-table';
Vue.use(VueGoodTablePlugin);

import VCalendar from 'v-calendar';
Vue.use(VCalendar);

import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput, {
    globalOptions: {
        currency: 'EUR',
        locale: 'nl-NL',
        precision: 2,
        'allow-negative': false,
    }
});

const moment = require('moment')
// require('moment/locale/nl') 
Vue.use(require('vue-moment'), {
    moment
})
moment.locale(window.default_locale);
 
import VueTimepicker from 'vue2-timepicker'
import { Chrome as colorPicker } from 'vue-color'
import Multiselect from 'vue-multiselect'
  
/**
 * Vue filters
 */
Vue.filter('translate', function(string) {
	if(!string) return '';

	return Vue.prototype.trans.get('strings.frontend.' + string);
});

Vue.filter('nl2br', function(string) {
	if(!string) return '';
	return string.replace(/(\r)*\n/g, '<br>');
});

Vue.filter('currency', function (string) {
    return '€ ' + parseFloat(string).toFixed(2);
});

/**
 * Vue init
 */
Vue.mixin({
    components: {
        VueTimepicker,
        colorPicker,
        Multiselect
    },
    data: function () {
        return {
            language: window.default_locale,
            routes: window.routes,
            current_user: window.current_user,
            settings: window.settings,

			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
            windowAspect: window.innerWidth / window.innerHeight,
            
            deleteConfirm:  Swal.mixin({
                                title: this.translate('delete_confirm.title'), 
                                text: this.translate('delete_confirm.text'),
                                confirmButtonText: this.translate('delete_confirm.confirm_button'),
                                cancelButtonText: this.translate('delete_confirm.cancel_button'),
                                icon: 'warning',
                                customClass: {
                                    confirmButton: 'btn btn-danger mr-3',
                                    cancelButton: 'btn btn-light'
                                },
                                showCancelButton: true,
                                buttonsStyling: false
            }),
            
            showLoader: _.throttle(this.doShowLoader, 300, { 'leading': false }),
        };
	},
	mounted() {
		window.onresize = () => {
			this.windowWidth = window.innerWidth;
			this.windowHeight = window.innerHeight;
			this.windowAspect = this.windowWidth / this.windowHeight;
		}
	},
	methods: {
		translate(string) {
			return Vue.prototype.trans.get('strings.frontend.' + string);
		},

		doShowLoader() {
			Swal.fire({
				title: this.translate('loading_title'),
				html: this.translate('loading_text'),
				allowOutsideClick: false,
				onBeforeOpen: () => {
					Swal.showLoading();
				}
			});
		},

        hideLoader() {
            this.showLoader.cancel();
			if(Swal.isVisible() && Swal.isLoading()) {
				Swal.close();
			}
		},
			
		hexToRgbArray(hex) {
			var c;
			if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
				c= hex.substring(1).split('');
				if(c.length== 3){
					c= [c[0], c[0], c[1], c[1], c[2], c[2]];
				}
				c= '0x'+c.join('');
				return [(c>>16)&255, (c>>8)&255, c&255];
			}
			return [255, 255, 255];
		},
		
		hexToRgbA(hex, alpha) {
			var c;
			if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
				c= hex.substring(1).split('');
				if(c.length== 3){
					c= [c[0], c[0], c[1], c[1], c[2], c[2]];
				}
				c= '0x'+c.join('');
				return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+', ' + alpha +')';
			}
			return hex;
			// throw new Error('Bad Hex');
		}
	},
	computed: {
		featherIframeWidth: function () {
			let videoAspect = 0.888;

			if(this.windowAspect > videoAspect) {
				return this.featherIframeHeight * 0.888;
			} else {
				return Math.round(window.innerWidth * 0.8);
			}
		},
		featherIframeHeight: function() {
			let videoAspect = 0.888;

			if(this.windowAspect > videoAspect) {
				return Math.round(this.windowHeight * 0.8);
			} else {
				return this.featherIframeWidth * 1.126;
			}
		},
	}
});
  
const app = new Vue({
    el: '#app',
});